import { Button } from "reactstrap";
import { Input } from "../common/style";
import styled from "styled-components";

const AuthButton = styled(Button)`
  height: 42px;
`;

const AuthContainer = styled.div`
  width: 500px;
  box-shadow:
    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
`;

const AuthInput = styled(Input)`
  margin-top: 25px;
  ${(props) =>
    props.$compact &&
    `
    margin-top: 0;
  `}
`;

export { AuthButton, AuthContainer, AuthInput };
